// extracted by mini-css-extract-plugin
export var animationContainer = "_ia-0";
export var asteriskIcon = "_ia-8";
export var conversationLeftSection = "_ia-4";
export var conversationListItem = "_ia-3";
export var conversationMiddleSection = "_ia-5";
export var conversationRightSection = "_ia-6";
export var detailsContent = "_ia-1";
export var listContainer = "_ia-7";
export var modalContent = "_ia-2";